export enum ResourceTypeEditMode {
  EDIT = 'edit',
  NEW = 'new',
}
